import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Spin, Row, Col, Input, Button, Modal, Form, message, Layout, InputNumber, Switch, Upload, Icon, Table } from 'antd'

import {tasteList, tasteCreate, tasteEdit} from '_src/api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
import { UploadIMGToOss } from '_src/utils/base'
import './taste.less'

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">图片上传</div>
  </div>
)

const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
}

class Taste extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: false,
      fileList: [],
      modelVisible: false,
      lookModelVisible: false,

      list: [],

      columns: [
        {
          title: <span>编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>标签图标</span>,
          dataIndex: 'tasteIcon',
          align: 'center',
          render: item => <img src={item} style={{width: 50, height: 50, cursor: 'pointer'}} alt='' onClick={()=>this.PrevImg.show(item)} />
        },
        {
          title: <span>标签兴趣名称</span>,
          dataIndex: 'tasteName',
          align: 'center',
        },
        {
          title: <span>标签权重</span>,
          dataIndex: 'sortOrder',
          align: 'center',
        },
        {
          title: <span>是否启用</span>,
          dataIndex: 'status',
          align: 'center',
          render: item => <div>{item === 1 ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : <Icon type="close-circle" theme="filled" style={{color: '#ccc', fontSize: 18}} /> }</div>
        },
        {
          title: <span>创建时间</span>,
          dataIndex: 'createAt',
          align: 'center',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <div>
            <Button icon="edit" onClick={() => { this.edit(item.id) }}>编辑</Button>
          </div>,
        },
      ]
    }
  }

  componentDidMount () {
    this.loadTaste()
  }

  loadTaste = () => {
    this.setState({ isLoading: true })
    tasteList()
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
        })
      })
  }

  // 查看元素 
  edit (id) {
    const {list} = this.state
    let info = list.filter(item => item.id === id)[0]
    const fileList = info.tasteIcon ? [{ uid: '-1', name: 'xxx.png', status: 'done', url: info.tasteIcon}] : []
    this.setState({
      isEdit: true,
      info,
      fileList,
      tasteIcon: info.tasteIcon,
      createModelVisible: true,
    })
  }

  create = () => {
    this.setState({
      createModelVisible: true
    })  
  }  

  // 创建元素
  createModal = (info) => {
    const {fileList} = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form">
        <Form.Item label="兴趣名：" className='flex'>
          {getFieldDecorator('tasteName', {
            rules: [{
              required: true,
              message: '请输入兴趣名',
            }],
            initialValue: info && info.tasteName ? info.tasteName : '',
          })(
            <Input placeholder="请输入兴趣名" />
          )}
        </Form.Item>
        <Form.Item label="排序权重：" className='flex'>
          {getFieldDecorator('sortOrder', {
            initialValue: info && info.sortOrder ? info.sortOrder : 1,
          })(
            <InputNumber placeholder="请输入排序权重" style={{width: 178}} min={1} max={10} />
          )}
        </Form.Item>
        <Form.Item label="是否启用：" className='flex'>
          {getFieldDecorator('status', {
            initialValue: !!(info && info.status === 1),
            valuePropName: 'checked'
          })(
            <Switch />
          )}
        </Form.Item>
        <Form.Item label="兴趣图标：" className='flex'>
          {getFieldDecorator('tasteIcon', {
            rules: [{
              required: true,
              message: '请上传兴趣图标',
            }],
            initialValue: info && info.tasteIcon ? info.tasteIcon : '',
          })(
            <Upload
              action=""
              listType="picture-card"
              fileList={fileList}
              onChange={this.handleChange}
              beforeUpload = {()=>{ return false }}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{width: 350, marginLeft: 30}}>保存</Button>
        </Form.Item>
      </Form>
    )
  }
  // 提交创建优惠券
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.sortOrder = Number(values.sortOrder)
        values.status = values.status ? 1 : 0
        // 处理图片
        const {fileList, tasteIcon, upload} = this.state
        if (upload && fileList.length) {
          // 图片需要上传
          const hide = message.loading('上传图片中', 0)
          UploadIMGToOss(fileList[0])
            .then((data) => {
              if (data) {
                hide()
                values.tasteIcon = data
                this.saveTaste(values)
              } else {
                message.error('图片上传失败！', 1.5)
              }
            })
            .catch(function (err) {
              message.error('图片上传失败！', 1.5)
              return false
            })
          return 
        } else if (tasteIcon) {
          values.tasteIcon = tasteIcon
          this.saveTaste(values)
          return
        } else {
          message.info('请上传兴趣图标')
          return
        }
      }
    })
  }

  saveTaste = (values) => {
    const {isEdit, info} = this.state
    if (isEdit) {
      values.id = info.id
      tasteEdit(values).then(res => {
        this.setState({
          createModelVisible: false,
          tasteIcon: '',
          info: '',
        })
        message.success('保存成功', 1.5, ()=>{
          this.loadTaste()
        })
      })
    } else {
      tasteCreate(values).then(res => {
        this.setState({
          createModelVisible: false,
          tasteIcon: '',
          info: '',
        })
        message.success('保存成功', 1.5, ()=>{
          this.loadTaste()
        })
      })
    }
  }

  handleChange = ({ fileList }) => {
    this.setState({ fileList, upload: true })
  }

  render () {
    const { createModelVisible, list, isLoading, columns, info } = this.state
    return (
      <Layout className="discount-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <div className='filter-inner'>
          <Row>
            <Col {...ColProps} xl={{ span: 10}} md={{ span: 8 }} className="flex-h-a">
              <Button className='creat-station' type="primary" icon="plus" style={{ marginBottom: 20, width: 160 }} onClick={this.create}>添加兴趣</Button>
            </Col>
          </Row>
          {!isLoading && <Table columns={columns} dataSource={list} bordered rowKey="id" pagination={false} />}

          <Modal
            title="编辑兴趣目录"
            visible={createModelVisible}
            onCancel={()=>{
              this.setState({ 
                createModelVisible: false,
                tasteIcon: '',
                info: '',
                fileList: [],
                upload: false,
              })  
            }}
            width={500}
            footer={false}
            destroyOnClose
          >
            {this.createModal(info)}
          </Modal>
        </div>
      </Layout>
    )
  }
}

export default connect()(Form.create({ name: '' })(Taste))